export const TEXT = 'text';
export const STATUS = 'status';